/**
 * OVERRIDE DefaultTemplate.jsx
 */

import DefaultTemplate from '../../../../../components/Blocks/Listing/DefaultTemplate';

export default DefaultTemplate;
